import React, { Fragment, Component } from "react";
import { properties } from "../constants/Propertise";
import { Alert } from 'reactstrap';

class AlertMessages extends Component {

  // Useless Constructor
  // constructor(props){
  //   super(props);
  // }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.isSucess === true) {
      setTimeout(() => {
        newProps.closeAlert();
      }, 1000);
    }
  }

  render() {
    return (
      <Fragment>
        {
          (
            (this.props.apiError === false &&
              this.props.isSucess === true &&
              this.props.isPending === false
            )
          ) &&
          <Alert
            color="success"
            isOpen={this.props.showAlert}
            toggle={this.props.closeAlert}
          >
            {
              (this.props.message !== '' && this.props.message !== undefined)
                ? this.props.message
                : properties.globalUserSuccessMessage
            }
          </Alert>
        }

        {
          (this.props.apiError && this.props.isSucess === false) &&
          <Alert
            color="danger"
            isOpen={this.props.showAlert}
            toggle={this.props.closeAlert}
          >
            {
              (this.props.message !== '' && this.props.message !== undefined)
                ? this.props.message
                : properties.globalUserErrorMessage
            }
          </Alert>
        }

        {
          this.props.isPending &&
          <Alert color="info">
            {properties.pleaseWaitText}
          </Alert>
        }

      </Fragment>
    )
  }

}

export default AlertMessages;